var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settle-page" },
    [
      _c("div", { staticClass: "settle-card" }, [
        _c("div", { staticClass: "settle-head" }, [
          _c("span", { staticClass: "settle-title" }, [_vm._v("店铺入驻申请")]),
          _c("span", { staticClass: "settle-login" }, [
            _vm._v(" 已有账号？"),
            _c(
              "a",
              { attrs: { href: "javascript:;" }, on: { click: _vm.goLogin } },
              [_vm._v("请登录>")]
            ),
          ]),
        ]),
        _c("p", { staticClass: "settle-tip" }, [
          _vm._v("温馨提示：请准确填写相关信息，确保信息真实有效。"),
        ]),
        _c(
          "div",
          { staticClass: "settle-body" },
          [
            _c(
              "el-form",
              {
                ref: "formRef",
                staticClass: "settle-form",
                attrs: { model: _vm.form, rules: _vm.rules },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "companyName" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入公司名称", maxlength: "60" },
                      model: {
                        value: _vm.form.companyName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "companyName", $$v)
                        },
                        expression: "form.companyName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "businessLicenseNo" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入18位统一社会信用代码",
                        maxlength: "18",
                      },
                      on: { input: _vm.normalizeBusinessLicenseNo },
                      model: {
                        value: _vm.form.businessLicenseNo,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "businessLicenseNo",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.businessLicenseNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "legalPersonName" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入法人姓名", maxlength: "20" },
                      model: {
                        value: _vm.form.legalPersonName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "legalPersonName", $$v)
                        },
                        expression: "form.legalPersonName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "legalPersonCertNo" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "password",
                        "show-password": "",
                        autocomplete: "off",
                        placeholder: "请输入法人身份证号",
                        maxlength: "18",
                      },
                      model: {
                        value: _vm.form.legalPersonCertNo,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "legalPersonCertNo",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.legalPersonCertNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "contactPerson" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入联系人", maxlength: "20" },
                      model: {
                        value: _vm.form.contactPerson,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "contactPerson", $$v)
                        },
                        expression: "form.contactPerson",
                      },
                    }),
                  ],
                  1
                ),
                _c("el-form-item", { attrs: { prop: "imageCaptcha" } }, [
                  _c(
                    "div",
                    { staticClass: "settle-row" },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入图片验证码",
                          maxlength: "10",
                        },
                        model: {
                          value: _vm.form.imageCaptcha,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "imageCaptcha", $$v)
                          },
                          expression: "form.imageCaptcha",
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "captcha-box",
                          attrs: { title: "点击刷新" },
                          on: { click: _vm.loadCaptcha },
                        },
                        [
                          _vm.captchaImg
                            ? _c("img", {
                                attrs: { src: _vm.captchaImg, alt: "验证码" },
                              })
                            : _c("span", { staticClass: "captcha-loading" }, [
                                _vm._v("加载中"),
                              ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-form-item", { attrs: { prop: "phone" } }, [
                  _c(
                    "div",
                    { staticClass: "settle-row" },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入联系方式",
                          maxlength: "11",
                        },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          staticClass: "sms-btn",
                          attrs: {
                            disabled: _vm.smsCountdown > 0 || _vm.sending,
                            loading: _vm.sending,
                          },
                          on: { click: _vm.onSendSms },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.smsCountdown > 0
                                  ? _vm.smsCountdown + "s 后重试"
                                  : "获取验证码"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { prop: "smsCode" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入手机验证码",
                        maxlength: "6",
                      },
                      model: {
                        value: _vm.form.smsCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "smsCode", $$v)
                        },
                        expression: "form.smsCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "mainBusiness" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        maxlength: "200",
                        placeholder: "请输入主营内容说明",
                      },
                      model: {
                        value: _vm.form.mainBusiness,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "mainBusiness", $$v)
                        },
                        expression: "form.mainBusiness",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "agreementAccepted" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.form.agreementAccepted,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "agreementAccepted", $$v)
                          },
                          expression: "form.agreementAccepted",
                        },
                      },
                      [_vm._v(" 阅读并同意 ")]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "settle-link",
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.openAgreement("settle")
                          },
                        },
                      },
                      [_vm._v("《店铺用户服务协议》")]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "settle-link",
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.openAgreement("privacy")
                          },
                        },
                      },
                      [_vm._v("《隐私保护政策》")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "submit-btn",
                    attrs: { type: "primary", loading: _vm.submitting },
                    on: { click: _vm.onSubmit },
                  },
                  [_vm._v(" 申请入驻 ")]
                ),
              ],
              1
            ),
            _vm._m(0),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.agreementTitle,
            visible: _vm.agreementVisible,
            width: "720px",
            top: "6vh",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.agreementVisible = $event
            },
          },
        },
        [
          _c("div", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.agreementLoading,
                expression: "agreementLoading",
              },
            ],
            staticClass: "agreement-box",
            domProps: { innerHTML: _vm._s(_vm.agreementContent || "暂无内容") },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.agreementVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "settle-illus" }, [
      _c("h3", [_vm._v("入驻流程")]),
      _c("ol", [
        _c("li", [_vm._v("填写并提交本页面的企业与联系人信息")]),
        _c("li", [_vm._v("平台人工审核资质（一般 1-3 个工作日）")]),
        _c("li", [_vm._v("审核通过后短信下发登录账号，回本站登录")]),
        _c("li", [_vm._v("登录后完善店铺信息、上架商品即可开店")]),
      ]),
      _c("p", { staticClass: "settle-illus-note" }, [
        _vm._v(
          " 提交后系统会自动核验企业名称、营业执照编号、法人姓名、法人身份证号四项信息， 请确保与营业执照、身份证原件完全一致，信息不符会被驳回。 手机号将作为后续登录账号与通知渠道，请填写常用号码。 "
        ),
      ]),
      _c("p", { staticClass: "settle-illus-note verify-notice" }, [
        _vm._v(
          " 提交时将实时进行企业四要素认证，通常需要数秒，请勿重复点击。 "
        ),
      ]),
      _c("p", { staticClass: "settle-illus-note" }, [
        _vm._v(" 法人身份证号仅用于企业资质核验，平台脱敏存储，不作他用。 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }